import { registerBeginnerLcdBlocks } from './lcd-blocks.js';
import { registerBeginnerOledBlocks } from './oled-blocks.js';
import { registerBeginnerTftBlocks } from './tft-blocks.js';

let registered = false;

/** Registers all Beginner Display blocks (LCD, OLED, TFT). */
export function registerBeginnerDisplayBlocks(): void {
  if (registered) {
    return;
  }
  registerBeginnerLcdBlocks();
  registerBeginnerOledBlocks();
  registerBeginnerTftBlocks();
  registered = true;
}
